(() => {
  const config = document.querySelector('script[data-tuanty-product-ui]');
  if (!config) return;

  const isProduct = document.body.classList.contains('hdt-page-type-product');
  const hosts = new Set();
  const widgets = new WeakSet();
  const drawers = new WeakSet();
  const stickies = new WeakSet();
  const hostAttempts = new WeakMap();
  let frame = 0;

  function setAttribute(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function syncOverlays() {
    frame = 0;
    const drawer = document.getElementById('CartDrawer');
    const cartOpen = !!drawer && ['open', 'opened', 'closing'].some((name) => drawer.hasAttribute(name));
    let clearance = 0;
    if (isProduct) {
      document.querySelectorAll('hdt-sticky-btn-atc').forEach((sticky) => {
        const rect = sticky.getBoundingClientRect();
        const style = getComputedStyle(sticky);
        if (rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && style.display !== 'none' && style.visibility !== 'hidden') {
          clearance = Math.max(clearance, Math.ceil(innerHeight - Math.max(0, rect.top)));
        }
      });
    }
    for (const host of hosts) {
      if (!host.isConnected) {
        hosts.delete(host);
        continue;
      }
      host.toggleAttribute('data-tuanty-cart-open', cartOpen);
      host.toggleAttribute('data-tuanty-pdp-sticky', clearance > 0);
      const value = `${clearance}px`;
      if (host.style.getPropertyValue('--tuanty-sticky-clearance') !== value) host.style.setProperty('--tuanty-sticky-clearance', value);
    }
  }

  function scheduleOverlays() {
    if (!frame) frame = requestAnimationFrame(syncOverlays);
  }

  function watchHost(host) {
    if (hosts.has(host) || !host.isConnected) return;
    const shadow = host.shadowRoot;
    if (!shadow) {
      const attempts = hostAttempts.get(host) || 0;
      if (attempts < 20) {
        hostAttempts.set(host, attempts + 1);
        setTimeout(() => watchHost(host), 250);
      }
      return;
    }
    const style = document.createElement('style');
    style.dataset.tuantyOfferUi = '';
    style.textContent = ':host([data-tuanty-cart-open]) #el__AfHMqnKhd{display:none!important}:host([data-tuanty-pdp-sticky]) #el__AfHMqnKhd{top:auto!important;bottom:calc(var(--tuanty-sticky-clearance,0px) + 12px + env(safe-area-inset-bottom,0px))!important}';
    shadow.append(style);
    new MutationObserver(() => {
      if (!style.isConnected && host.isConnected) shadow.append(style);
    }).observe(shadow, { childList: true });
    hosts.add(host);
    scheduleOverlays();
  }

  function improveReviews(widget) {
    const average = widget.querySelector('.jm-review-widget__header .jm-average-rating-display');
    const cluster = average?.querySelector(':scope > .jm-cluster');
    if (cluster) {
      const texts = [...cluster.children].filter((element) => element.matches('p.jm-text'));
      const productId = widget.dataset.productId || widget.dataset.id;
      const data = window.jdgm?.data?.reviewWidget?.[productId];
      const rating = Number(data?.average_rating);
      const displayed = Number(texts[0]?.textContent.trim().replace(',', '.'));
      if (texts.length === 2 && data && Number(data.number_of_reviews) > 0 && Number.isFinite(rating) && rating >= 0 && rating <= 5 && Number.isFinite(displayed) && Math.abs(displayed - rating) < 0.11) {
        let stars = cluster.querySelector('.tuanty-review-summary-stars');
        if (!stars) {
          stars = document.createElement('span');
          stars.className = 'tuanty-review-summary-stars';
          stars.setAttribute('role', 'img');
          for (let index = 0; index < 5; index += 1) {
            const star = document.createElement('span');
            star.className = 'tuanty-review-summary-star';
            star.setAttribute('aria-hidden', 'true');
            stars.append(star);
          }
          cluster.insertBefore(stars, texts[0]);
        }
        if (stars.dataset.rating !== String(rating)) {
          stars.dataset.rating = String(rating);
          const value = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 2 }).format(rating);
          stars.setAttribute('aria-label', `${value} / 5`);
          [...stars.children].forEach((star, index) => {
            star.style.setProperty('--tuanty-star-fill', `${Math.min(100, Math.max(0, Math.round((rating - index) * 100)))}%`);
          });
        }
        if (!texts[0].classList.contains('tuanty-review-average-number')) texts[0].classList.add('tuanty-review-average-number');
      }
    }

    const pagination = widget.querySelector('.jm-pagination-controls');
    const buttons = pagination?.querySelectorAll('.jm-pagination-controls__button--nav');
    if (buttons?.length === 2) {
      [config.dataset.previousLabel, config.dataset.nextLabel].forEach((label, index) => {
        if (!label) return;
        const button = buttons[index];
        let text = button.querySelector('.tuanty-review-page-label');
        if (!text) {
          text = document.createElement('span');
          text.className = 'tuanty-review-page-label';
          button.append(text);
        }
        if (text.textContent !== label) text.textContent = label;
        setAttribute(button, 'aria-label', label);
      });
      widget.toggleAttribute('data-tuanty-review-pages-ready', true);
    } else {
      widget.removeAttribute('data-tuanty-review-pages-ready');
    }
  }

  function watchWidget(widget) {
    if (!isProduct || widgets.has(widget)) return;
    widgets.add(widget);
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        if (widget.isConnected) improveReviews(widget);
      });
    }).observe(widget, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-label', 'aria-current'] });
    improveReviews(widget);
  }

  function watchDrawer(drawer) {
    if (drawers.has(drawer)) return;
    drawers.add(drawer);
    new MutationObserver(scheduleOverlays).observe(drawer, { attributes: true, attributeFilter: ['open', 'opened', 'closing'] });
    scheduleOverlays();
  }

  function watchSticky(sticky) {
    if (!isProduct || stickies.has(sticky)) return;
    stickies.add(sticky);
    new ResizeObserver(scheduleOverlays).observe(sticky);
    new IntersectionObserver(scheduleOverlays).observe(sticky);
    scheduleOverlays();
  }

  const targets = [
    ['.mcforms-wrapper', watchHost],
    ['#CartDrawer', watchDrawer],
    ['#judgeme_product_reviews', watchWidget],
    ['hdt-sticky-btn-atc', watchSticky],
  ];
  function discover(root) {
    for (const [selector, watch] of targets) {
      if (root.matches?.(selector)) watch(root);
      root.querySelectorAll?.(selector).forEach(watch);
    }
  }
  discover(document);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) if (node.nodeType === Node.ELEMENT_NODE) discover(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
  if (isProduct) {
    addEventListener('scroll', scheduleOverlays, { passive: true });
    addEventListener('resize', scheduleOverlays, { passive: true });
  }
})();
